export const recordPerformanceMark = (name: string) => {
  performance.mark?.(name);
};
